import { createSlice } from "@reduxjs/toolkit"
import fetchJobType from "sr/redux/action/master/jobTypeAction"

interface JobTypeState {
  data: any
  error: string | null
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
}

const initialState: JobTypeState = {
  data: null,
  error: null,
  status: 'idle',
}

const jobTypeSlice = createSlice({
  name: 'jobtype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobType.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchJobType.fulfilled, (state, action) => {
        state.status = 'succeeded'
        console.log(action)
        state.data = action.payload
      })
      .addCase(fetchJobType.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch job type data'
      })
  },
})

export default jobTypeSlice.reducer
